var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMur = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_15890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.45898 6.52819L11.9999 7.57168L22.5408 6.52819C20.5056 2.79807 16.5484 0.267334 11.9999 0.267334C7.45139 0.267334 3.49425 2.79807 1.45898 6.52819Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.45908 18.007L12 19.0505L22.5409 18.007C23.4711 16.3021 24 14.3468 24 12.2678L12 11.2244L0 12.2678C0 14.3468 0.528891 16.3021 1.45908 18.007Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.45908 6.52905C0.528891 8.23394 0 10.1893 0 12.2682H24C24 10.1893 23.4711 8.23394 22.5409 6.52905H12H1.45908Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 24.2665C16.5484 24.2665 20.5056 21.7357 22.5408 18.0056H1.45898C3.49425 21.7357 7.45139 24.2665 11.9999 24.2665Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_15890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMur);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/MUR.d73559bec7e6028c5bdde215aa4f61b4.svg";